import React from 'react';
import Download from '../assets/images/DownloadIcon.svg';

export default () => {
  return <img src={Download} alt="" />;
};
